import React, { useState, useEffect, useContext, useRef } from "react";
import AdminContext from "../../../StateContext/Application";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../../styles/GooglePagination";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatDateTime, formatDate } from "../../../../../utils/DateFormat";

const RESTRICTED_HEADTYPE_ROLES = [24, 25, 40, 41];

const RejectedWorksTracker = () => {
  const { t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetRejectedWorksList, GetBudgetHeadInfo, Usermenu, Getyears } = context;

  const [allRecords, setAllRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [allDistrict, setAllDistrict] = useState([]);
  const [roleID, setRoleID] = useState(null);

  const [filterDistrict, setFilterDistrict] = useState("");
  const [filterTaluka, setFilterTaluka] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterHeadType, setFilterHeadType] = useState("");
  const [filterWorkOrderType, setFilterWorkOrderType] = useState("");
  const [filterStage, setFilterStage] = useState("");

    const [showspecific, setShowSpecific] = useState(0);
  const [selectedBillData, setselectedBillData] = useState({});
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [fetchSpecificDemandDeductionDetail, setfetchSpecficDemandDeductionDetail] = useState([]);
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);

  const billSlipRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;

  const stages = [
    "Proposal Creation",
    "GR Stage",
    // "Technical Sanction",
    // "Work Order",
    // "Physical Progress",
    "Bill Stage",
  ];

  const isHeadTypeRestricted = RESTRICTED_HEADTYPE_ROLES.includes(roleID);

  const fetchRoleID = async () => {
    try {
      const data = await Usermenu();
      const rID = data?.Data?.RoleID;
      setRoleID(rID);
    } catch (err) {
      console.log("Error fetching role:", err);
    }
  };

  const fetchData = async () => {
  setLoading(true);
  try {
    const res = await GetRejectedWorksList({
      filterDistrict,
      filterTaluka,
      filterYear,
      filterHeadType: isHeadTypeRestricted ? "" : filterHeadType,
      filterWorkOrderType,
      filterStage,
    });

    if (!res?.status || !Array.isArray(res?.message)) {
      console.log("GetRejectedWorksList failed:", res?.message);
      setAllRecords([]);
      setFilteredRecords([]);
      setCurrentPage(1);
      return;
    }

    setAllRecords(res.message);
    setFilteredRecords(res.message);
    setCurrentPage(1);
  } catch (err) {
    console.log("Error fetching rejected works:", err);
    setAllRecords([]);
    setFilteredRecords([]);
  } finally {
    setLoading(false);
  }
};

  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await GetRejectedWorksList({
  //       filterDistrict,
  //       filterTaluka,
  //       filterYear,
  //       // Never send a HeadType override for restricted roles —
  //       // the backend forces it by RoleID anyway, but this keeps intent clear.
  //       filterHeadType: isHeadTypeRestricted ? "" : filterHeadType,
  //       filterWorkOrderType,
  //       filterStage,
  //     });
  //     const data = res?.message || [];
  //     setAllRecords(data);
  //     setFilteredRecords(data);
  //     setCurrentPage(1);
  //   } catch (err) {
  //     console.log("Error fetching rejected works:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchDistricts = async () => {
    try {
      const res = await GetBudgetHeadInfo("null", "AllDistrict");
      setAllDistrict(res || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchRoleID();
    fetchDistricts();
  }, []);

  useEffect(() => {
    // Wait until roleID is resolved (null on first render) before firing,
    // so the very first fetch already reflects the correct restriction.
    if (roleID !== null) {
      fetchData();
    }
  }, [
    roleID,
    filterDistrict,
    filterTaluka,
    filterYear,
    filterHeadType,
    filterWorkOrderType,
    filterStage,
  ]);

  const totalPages = Math.ceil(filteredRecords.length / perPage);
  const start = (currentPage - 1) * perPage;
  const currentRows = filteredRecords.slice(start, start + perPage);

  const uniqueTalukas = [
    ...new Set(
      allDistrict
        .filter((d) => d.District_Marathi === filterDistrict)
        .map((d) => d.ULBNameMarathi || d.ULBName),
    ),
  ];

    const settingshowspecific3 = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(4);

      let filtered = res.filter((val) => val.DemandGenerationID == ID);
      setselectedBillData(filtered[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setselectedBillData({});
    setShowSpecific(0);
  };

  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }
    setExportingBillSlipPDF(true);
    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;
      const ratio = Math.min(maxImgWidth / canvas.width, maxImgHeight / canvas.height);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight
      );

      const transactionNo = selectedBillData?.DemandGenerationID || selectedDemandID;
      pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);
      alert("Failed to export bill slip PDF. Please try again.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };

  const labelStyle = {
    border: "1px solid #000",

    padding: "6px",

    width: "18%",

    fontWeight: "bold",

    background: "#f5f5f5",
  };

  const valueStyle = {
    border: "1px solid #000",

    padding: "6px",
  };

  const tableHead = {
    border: "1px solid #000",

    background: "#d9d9d9",

    padding: "8px",

    textAlign: "center",
  };

  const tableCell = {
    border: "1px solid #000",

    padding: "8px",

    textAlign: "center",
  };

  const vendorData = fetchSpecificDemandDeductionDetail?.find(
    (item) => item.TypeOfAmount === "Total Amount Payable",
  );

  const officerStyle = {
    marginTop: "8px",

    fontSize: "12px",

    fontWeight: "bold",

    textAlign: "center",
  };

  const officerMarathiStyle = {
    fontSize: "11px",

    textAlign: "center",

    marginTop: "3px",
  };

  const footerTitleStyle = {
    width: "100%",

    borderCollapse: "collapse",

    marginTop: "8px",
  };

  const footerTitleTdStyle = {
    border: "1px solid #555",

    padding: "6px",

    textAlign: "center",

    fontSize: "12px",

    fontWeight: "bold",
  };

  const remarksTableStyle = {
    width: "100%",

    borderCollapse: "collapse",
  };

  const remarksTableTdStyle = {
    border: "1px solid #555",

    padding: "8px",

    fontSize: "11px",

    lineHeight: "18px",

    textAlign: "right",
  };

  const instructionTableStyle = {
    width: "100%",

    borderCollapse: "collapse",

    marginTop: "-1px",
  };

  const instructionTableTdStyle = {
    border: "1px solid #555",

    padding: "10px",

    fontSize: "11px",

    lineHeight: "18px",

    textAlign: "justify",
  };

  const signatureTableStyle = {
    width: "100%",

    tableLayout: "fixed",

    borderCollapse: "collapse",

    marginTop: "-1px",
  };

  const signatureTableTdStyle = {
    border: "1px solid #555",

    height: "80px",

    width: "50%",

    verticalAlign: "bottom",

    padding: "10px",
  };

  const signBoxStyle = {
    width: "100%",

    height: "100%",

    display: "flex",

    flexDirection: "column",

    justifyContent: "flex-end",
  };

  const signSpaceStyle = {
    height: "25px",
  };

  const signTitleStyle = {
    fontSize: "12px",

    fontWeight: "bold",

    textAlign: "center",
  };

  return (
    <>
    {showspecific === 0 && (
    <div
      className="col-12"
      style={{
        backgroundColor: "#EFF3F8",
        height: "80vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      <div className="col-11 m-auto">
        <h5 className="fw-bold mb-3">{t("Rejected Works Tracker")}</h5>

        {/* ===== FILTERS ===== */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            marginBottom: "16px",
          }}
        >
          <select
            value={filterDistrict}
            onChange={(e) => {
              setFilterDistrict(e.target.value);
              setFilterTaluka("");
            }}
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "160px",
            }}
          >
            <option value="">{t("District")}</option>
                {[
                  ...new Set(
                    allDistrict
                      .map((d) => d.District_Marathi?.split("-")[0]?.trim())
                      .filter(Boolean)
                  ),
                ].map((d, i) => (
                  <option key={i} value={d}>
                    {d}
                  </option>
                ))}
          </select>

          <select
            value={filterTaluka}
            onChange={(e) => setFilterTaluka(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "160px",
            }}
          >
            <option value="">{t("Taluka")}</option>
            {uniqueTalukas.map((tal, i) => (
              <option key={i} value={tal}>
                {tal}
              </option>
            ))}
          </select>

          <select
            value={filterYear}
            onChange={(e) => setFilterYear(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "140px",
            }}
          >
            <option value="">{t("All Years")}</option>
            {["2019-2020", "2020-2021", "2021-2022", "2022-2023", "2023-2024", "2024-2025", "2025-2026", "2026-2027"].map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>

          <select
            value={filterWorkOrderType}
            onChange={(e) => setFilterWorkOrderType(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "180px",
            }}
          >
            <option value="">{t("Work Order Type")}</option>
            <option value="New Work Order">{t("New Work Order")}</option>
            <option value="Existing Work Order">{t("Existing Work Order")}</option>
          </select>

          {/* Hidden entirely for RoleID 24, 25, 40, 41 — their HeadCode
              scope (3054 / 2515) is fixed server-side and can't be changed. */}
          {!isHeadTypeRestricted && (
            <select
              value={filterHeadType}
              onChange={(e) => setFilterHeadType(e.target.value)}
              style={{
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                width: "160px",
              }}
            >
              <option value="">{t("Budget Head")}</option>
              <option value="District">{t("3054 - District")}</option>
              <option value="State">{t("2515 - State")}</option>
            </select>
          )}

          <select
            value={filterStage}
            onChange={(e) => setFilterStage(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "180px",
            }}
          >
            <option value="">{t("Stage")}</option>
            {stages.map((s, i) => (
              <option key={i} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        {/* ===== TABLE ===== */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0px 0px 5px 1px #E4E8EC",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#2C78DB", color: "white", height: "3rem", fontSize: "18px" }}>
                <th style={{ padding: "8px" }}>{t("Sr.No.")}</th>
                <th style={{ padding: "8px" }}>{t("Demand ID")}</th>
                <th style={{ padding: "8px" }}>{t("Work Name")}</th>
                <th style={{ padding: "8px" }}>{t("District")}</th>
                <th style={{ padding: "8px" }}>{t("Taluka")}</th>
                <th style={{ padding: "8px" }}>{t("Year")}</th>
                <th style={{ padding: "8px" }}>{t("Stage")}</th>
                <th style={{ padding: "8px" }}>{t("Rejected By (Role)")}</th>
                <th style={{ padding: "8px" }}>{t("Work Order Type")}</th>
                <th style={{ padding: "8px" }}>{t("Remark")}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ fontSize: "18px" }}>
                  <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
                    {t("Loading...")}
                  </td>
                </tr>
              ) : currentRows.length === 0 ? (
                <tr style={{ fontSize: "18px" }}>
                  <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
                    {t("No rejected records found")}
                  </td>
                </tr>
              ) : (
                currentRows.map((row, idx) => (
                  <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px" }}>
                    <td style={{ padding: "8px" }}>{start + idx + 1}</td>
                    <td style={{ padding: "8px" }}>
  {row.Stage === "Bill Creation" ? (
    row.DemandID ? (
      <span
        onClick={() => settingshowspecific3(row.DemandID)}
        style={{
          color: "#0d6efd",
          textDecoration: "underline",
          cursor: "pointer",
          fontWeight: "500",
        }}
      >
        {row.DemandID}
      </span>
    ) : (
      "-"
    )
  ) : (
    "-"
  )}
</td>
                    <td style={{ padding: "8px" }}>{row.WorkName || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.District || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.Taluka || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.Year || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.Stage}</td>
                    <td style={{ padding: "8px" }}>{row.RejectedByRole || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.WorkOrderType || "-"}</td>
                    <td style={{ padding: "8px" }}>{row.Remark || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <p>
              {t("Showing")} {start + 1} -{" "}
              {Math.min(start + perPage, filteredRecords.length)} {t("of")}{" "}
              {filteredRecords.length}
            </p>
            <GooglePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </div>
    )}

    {showspecific === 4 && (
                  <>
                    <div className="col-12 m-auto">
                      <div
                        className="col-12 m-auto my-15 mb-10 budgetContainer "
                        style={{
                          maxHeight: "85vh", // or 700px
        
                          overflowY: "auto",
        
                          overflowX: "hidden",
        
                          border: "1px solid #ddd",
        
                          borderRadius: "8px",
                        }}
                      >
                        <div className="m-auto budgetElement">
                          {/* Heading */}
        
                          {/* TABLE CONTAINER */}
        
                          <div
                            className="mt-3 d-flex justify-content-between"
                            style={{
                              position: "relative",
        
                              alignItems: "center",
        
                              background: "#fff",
                            }}
                          >
                            {/* TITLE – LEFT */}
        
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <img
                                src="/Bill-files64.png"
                                alt="MAS Slip"
                                width="26"
                                height="26"
        
                                // style={{ transform: "translateY(9px)", }}
                              />
        
                              <h5 className="m-0 fw-bold">Bill Slip</h5>
                            </div>
        
                            {/* BACK BUTTON – TOP RIGHT */}
        
                            <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                              <button
                                className="btn btn-primary d-flex align-items-center gap-2"
                                style={{
                                  borderRadius: "999px",
        
                                  padding: "6px 22px",
        
                                  fontSize: "14px",
        
                                  zIndex: 10,
                                }}
                                onClick={exportBillSlipPDF}
                                disabled={exportingBillSlipPDF}
                              >
                                {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
                              </button>
        
                              <button
                                className="btn btn-danger d-flex align-items-center gap-2"
                                style={{
                                  top: "12px",
        
                                  right: "12px",
        
                                  borderRadius: "999px",
        
                                  padding: "6px 22px",
        
                                  fontSize: "14px",
        
                                  zIndex: 10,
                                }}
                                onClick={BackFunction}
                              >
                                {/* <img
        
                                src={Back32}
        
                                alt="back"
        
                                width="14"
        
                                height="14"
        
                                // style={{ filter: "brightness(0) invert(1)" }}
        
                              /> */}
                                Back
                              </button>
                            </div>
                          </div>
        
                          <div ref={billSlipRef}>
                            <div
                              className="text-center text-white py-3"
                              style={{
                                background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                              }}
                            >
                              <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                                Zila Parishad - {selectedBillData.District}
                              </div>
        
                              {/* <div style={{ fontSize: "15px", fontWeight: "bold" }}>
                                प्रशासकीय मंजुरी वर्ष - 2026-2027
                              </div>
        
                              <div>
                                विभाग - EXE.ENGINEER ZP Division{" "}
                                {selectedBillData.Division}
                              </div>
        
                              <div>उप-विभाग - {selectedBillData.District}</div>
        
                              <div class="small">
                                या तपशीलवार शीर्षाचे देयकासाठी आवश्यक असेल तिथे वित्त
                                विभागाचा अनौपचारिक संदर्भ तपासावा.
                              </div> */}
                            </div>
        
                            <div className="border border-dark p-1">
                              <table
                                className="table mb-0"
                                style={{ fontSize: "18px", border: "none" }}
                              >
                                <tbody>
                                  {/* <tr>
        
                                  <td className='text-start'>
        
                                    <span>UserName :</span>
        
        
        
                                  </td>
        
                                  <td className='text-end'>
        
                                    <span>DateTime : </span>
        
                                  </td>
        
                                </tr> */}
        
                                  <tr>
                                    <td
                                      colSpan={2}
                                      className="fw-bold text-center fs-6 p-1"
                                    >
                                      {" "}
                                      Bill Slip for RDD
                                    </td>
                                  </tr>
        
                                  {[
                                    [
                                      "User Name",
                                      `${selectedBillData.UploadedBy ?? "-"}`,
                                    ],
                                    [
                                      "Demand ID",
                                      `${selectedBillData.DemandGenerationID ?? "-"}`,
                                    ],
                                    [
                                      "Bill Creation Date",
                                      formatDateTime(selectedBillData.UploadedOn)
                                      ,
                                    ],
                                    [
                                      "Head Code",
                                      `${selectedBillData.BudgetID ?? "-"}`,
                                    ],
                                    [
                                      "Work Name",
                                      `${selectedBillData.ProjectID ?? "-"}`,
                                    ],
                                    [
                                      "Class of Work",
                                      `${selectedBillData.classOfWork || selectedBillData.workClass || "-"}`,
                                    ],
                                    [
                                      "Work Approved Year",
                                      `${selectedBillData.ProposalYear ?? "-"}`,
                                    ],
                                    [
                                      "Work order date",
                                      formatDate(selectedBillData.WorkOrderDate),
                                      ,
                                    ],
                                    [
                                      "Work Approved Amount",
                                      `${selectedBillData.ApprovedWorkAmount ?? "-"}`,
                                    ],
                                    [
                                      "Gross Bill Amount",
                                      `${selectedBillData.BillAmount ?? "-"}`,
                                    ],
                                    [
                                      "R.A.Bill No:",
                                      `${selectedBillData.RABillNumber ?? "-"}`,
                                    ],
        
                                    [
                                      "Invoice Bill No",
                                      `${selectedBillData.InvoiceNo ?? "-"}`,
                                    ],
                                  ].map(([label, value], index) => (
                                    <tr
                                      key={index}
                                      style={{ border: "1.5px solid #1190CA" }}
                                    >
                                      <td
                                        className="text-start"
                                        style={{
                                          width: "30%",
        
                                          backgroundColor: "#EAF3FB",
        
                                          fontWeight: 500,
        
                                          padding: "6px 10px",
        
                                          borderRight: "1.5px solid #1190CA",
                                        }}
                                      >
                                        {label}
                                      </td>
        
                                      <td
                                        className="text-start"
                                        style={{
                                          width: "70%",
        
                                          padding: "6px 10px",
        
                                          backgroundColor: "#FFFFFF",
                                        }}
                                      >
                                        {value}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
        
                              <table
                                className="mt-1"
                                style={{
                                  borderCollapse: "collapse",
        
                                  border: "1px solid #000",
                                }}
                              >
                                <tbody>
                                  <tr className="border border-dark">
                                    <td
                                      className="text-start border border-dark "
                                      style={{ width: "30%" }}
                                    >
                                      Bill Amount
                                    </td>
        
                                    <td
                                      className="text-start border border-dark"
                                      style={{ width: "23%" }}
                                    >
                                      Deduction Amount
                                    </td>
        
                                    <td
                                      className="text-start border border-dark "
                                      style={{ width: "24%" }}
                                    >
                                      Net Payable
                                    </td>
                                  </tr>
        
                                  <tr>
                                    <td className="text-start border border-dark">
                                      {selectedBillData.BillAmount}
                                    </td>
        
                                    <td className="text-start border border-dark">
                                      {selectedBillData.DeductionAmount}
                                    </td>
        
                                    <td className="text-start border border-dark">
                                      {selectedBillData.NetPayableAmount}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
        
                              {/* Vendor Details */}
        
                              <table
                                className="mt-2"
                                style={{
                                  width: "100%",
        
                                  borderCollapse: "collapse",
        
                                  fontSize: "18px",
                                }}
                              >
                                <tbody>
                                  {/* Section Title */}
        
                                  <tr
                                    style={{
                                      border: "1.5px solid #1190CA",
        
                                      backgroundColor: "#EAF3FB",
                                    }}
                                  >
                                    <td
                                      colSpan="6"
                                      style={{
                                        padding: "8px 10px",
        
                                        fontWeight: 600,
        
                                        textAlign: "center",
                                      }}
                                    >
                                      Vendor Details
                                    </td>
                                  </tr>
        
                                  {/* Column Headers */}
        
                                  <tr style={{ border: "1.5px solid #1190CA" }}>
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        fontWeight: 500,
        
                                        backgroundColor: "#1190CA",
        
                                        color: "white",
                                      }}
                                    >
                                      Vendor Name
                                    </td>
        
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        fontWeight: 500,
        
                                        backgroundColor: "#1190CA",
        
                                        color: "white",
                                      }}
                                    >
                                      IFSC Code
                                    </td>
        
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        fontWeight: 500,
        
                                        backgroundColor: "#1190CA",
        
                                        color: "white",
                                      }}
                                    >
                                      Branch Name
                                    </td>
        
                                    <td
                                      style={{
                                        padding: "6px 8px",
                                        fontWeight: 500,
                                        backgroundColor: "#1190CA",
                                        color: "white",
                                      }}
                                    >
                                      Bank Name
                                    </td>
        
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        fontWeight: 500,
        
                                        backgroundColor: "#1190CA",
        
                                        color: "white",
                                      }}
                                    >
                                      Account Number
                                    </td>
        
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        fontWeight: 500,
        
                                        backgroundColor: "#1190CA",
        
                                        color: "white",
                                      }}
                                    >
                                      Amount{" "}
                                    </td>
                                  </tr>
        
                                  {fetchSpecificDemandDeductionDetail &&
                                    fetchSpecificDemandDeductionDetail
        
                                      .filter(
                                        (val) =>
                                          val.TypeOfAmount == "Total Amount Payable",
                                      )
        
                                      .map((val, index) => {
                                        return (
                                          <>
                                            <tr
                                              style={{ border: "1.5px solid #1190CA" }}
                                              key={index}
                                            >
                                              <td
                                                style={{
                                                  padding: "6px 8px",
        
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.Vendor_Company_Name}
                                              </td>
        
                                              <td
                                                style={{
                                                  padding: "6px 8px",
        
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.Bank_IFSC_Code}
                                              </td>
        
                                              <td
                                                style={{
                                                  padding: "6px 8px",
        
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.Branch_Name}
                                              </td>
        
                                              <td
                                                style={{
                                                  padding: "6px 8px",
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.BANK_NAME}
                                              </td>
        
                                              <td
                                                style={{
                                                  padding: "6px 8px",
        
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.Bank_Account_Number}
                                              </td>
        
                                              <td
                                                style={{
                                                  padding: "6px 8px",
        
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                {val.TotalAmount}
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      })}
        
                                  <tr style={{ border: "1.5px solid #1190CA" }}>
                                    <td
                                      style={{
                                        padding: "6px 8px",
        
                                        backgroundColor: "#EAF3FB",
        
                                        fontWeight: 500,
                                      }}
                                      colSpan={5}
                                    >
                                      Total
                                    </td>
        
                                    <td className="border border-dark">
                                      {selectedBillData.NetPayableAmount}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
        
                              <table
                                className="my-2"
                                style={{ width: "100%", borderCollapse: "collapse" }}
                              >
                                <thead>
                                  <tr
                                    style={{
                                      border: "1.5px solid #1190CA",
        
                                      backgroundColor: "#EAF3FB",
                                    }}
                                  >
                                    <td
                                      colSpan="6"
                                      style={{
                                        padding: "8px 10px",
        
                                        fontWeight: 600,
        
                                        textAlign: "center",
                                      }}
                                    >
                                      Deduction Amount Details
                                    </td>
                                  </tr>
        
                                  <tr
                                    style={{
                                      color: "white",
        
                                      border: "none",
        
                                      height: "3rem",
                                    }}
                                  >
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      Sr No
                                    </th>
        
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      Deduction Type
                                    </th>
        
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      Deduction Amount{" "}
                                    </th>
        
                                    {/* <th style={{ minWidth: "60px", padding: "8px" }}>
        
                                  Vendor Name
        
                                </th> */}
        
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      Account Number
                                    </th>
        
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      Bank Name
                                    </th>
        
                                    <th style={{ minWidth: "60px", padding: "8px" }}>
                                      IFSC
                                    </th>
                                  </tr>
                                </thead>
        
                                <tbody>
                                  {fetchSpecificDemandDeductionDetail.filter(
                                    (val) => val.TypeOfAmount != "Total Amount Payable",
                                  )?.length == 0 ? (
                                    <tr>
                                      <td
                                        colSpan="30"
                                        style={{
                                          textAlign: "center",
        
                                          padding: "20px",
        
                                          backgroundColor: "#f9f9f9",
                                        }}
                                      >
                                        No data available
                                      </td>
                                    </tr>
                                  ) : (
                                    fetchSpecificDemandDeductionDetail
        
                                      .filter(
                                        (val) =>
                                          val.TypeOfAmount != "Total Amount Payable",
                                      )
        
                                      .map((technicalInwards, index) => {
                                        const bgColor =
                                          index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
        
                                        return (
                                          <tr
                                            className="px-3"
                                            key={index}
                                            style={{
                                              borderBottom: "1px solid #3b409e",
        
                                              backgroundColor: bgColor,
                                              fontSize: "18px",
                                            }}
                                          >
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {index + 1}
                                            </td>
        
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {technicalInwards.TypeOfAmount}
                                            </td>
        
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {technicalInwards.TotalAmount}
                                            </td>
        
                                            {/* <td
        
                                          style={{ fontSize: "12px", padding: "5px" }}
        
                                        >
        
                                          {technicalInwards.Vendor_Company_Name}
        
                                        </td> */}
        
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {technicalInwards.Bank_Account_Number}
                                            </td>
        
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {technicalInwards.Bank_Name}
                                            </td>
        
                                            <td
                                              style={{
                                                fontSize: "13px",
                                                padding: "5px",
                                              }}
                                            >
                                              {technicalInwards.Bank_IFSC_Code}
                                            </td>
                                          </tr>
                                        );
                                      })
                                  )}
        
                                  <tr
                                    style={{
                                      border: "1.5px solid #1190CA",
        
                                      fontWeight: 600,
        
                                      background: "white",
                                    }}
                                  >
                                    <td
                                      colSpan="2"
                                      style={{ padding: "6px 8px", textAlign: "right" }}
                                    >
                                      Total
                                    </td>
        
                                    <td style={{ padding: "6px 8px" }}>
                                      {selectedBillData.DeductionAmount}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
        
                              {/* Signature grid */}
        
                              <table style={footerTitleStyle}>
                                <tbody>
                                  <tr>
                                    <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
                                  </tr>
                                </tbody>
                              </table>
        
                              <table style={remarksTableStyle}>
                                <tbody>
                                  <tr>
                                    <td style={remarksTableTdStyle}>
                                      प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत
                                      करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च
                                      करण्यात येणार आहे.
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
        
                              <table style={remarksTableStyle}>
                                <tbody>
                                  <tr>
                                    <td style={remarksTableTdStyle}>
                                      स्वाक्षरी आहरण व संवितरण अधिकारी
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
        
                              <table style={instructionTableStyle}>
                                <tbody>
                                  <tr>
                                    <td style={instructionTableTdStyle}>
                                      दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे
                                      प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या
                                      अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात
                                      नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी
                                      ग्रामविकास विभाग मुबई येथे सादर करण्यात आले
                                      नव्हते. प्रमाणित करण्यात येते की वरील मागणी ही
                                      महाराष्ट्र कोषागार नियम / मुंबई वित्तीय नियम /
                                      महाराष्ट्र आकस्मिक खर्च नियम व वेळोवेळी विहित
                                      केलेल्या आदेशांच्या आधारे तयार करण्यात आली आहे.
                                      श्री. किंवा श्रीमती ______________________________
                                      यांना सदर देयकाची रक्कम/किंवा अपेक्षित देयक प्रदान
                                      करीता प्राधिकृत करण्यात आले असून त्यांची स्वाक्षरी
                                      खालीलप्रमाणे आहे.
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
    </>
  );
};

export default RejectedWorksTracker;